import { Link } from 'react-router-dom';
import { usePageMeta } from '@/hooks/useSEO';
import { ArrowRight, Scale } from 'lucide-react';
import { COMPARISON_LIST } from './comparisonData';

/** Comparison Hub — `/study-abroad/comparison/` — index of all head-to-head guides. */
const ComparisonIndexPage = () => {
  usePageMeta(
    'Study Destination Comparisons 2026 | Canada vs UK, Germany vs Canada & More',
    'Honest head-to-head 2026 comparisons for Indian students: Canada vs UK for PR, UK vs Australia for MBA, Germany vs UK for data science, Ireland vs UK and more.',
    { canonical: '/study-abroad/comparison/' },
  );

  return (
    <div className="bg-white zaf-prose" data-testid="comparison-index-page">
      <section
        className="relative overflow-hidden text-white"
        style={{ background: 'linear-gradient(135deg, #003087 0%, #001F5C 55%, #020617 100%)' }}
      >
        <div aria-hidden="true" className="pointer-events-none absolute -top-32 -right-24 w-96 h-96 rounded-full bg-[#C5A028]/14 blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-6 py-14 lg:py-24">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/8 border border-white/15 text-[10.5px] font-bold tracking-[0.22em] text-[#FACC15] uppercase mb-5">
            <Scale className="w-3.5 h-3.5" aria-hidden="true" /> Decision Guides · 2026
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-[48px] font-bold font-syne leading-[1.12] tracking-tight mb-4 max-w-3xl" data-testid="cmp-index-h1">
            Head-to-Head Destination <span className="text-[#FACC15]">Comparisons</span>
          </h1>
          <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl">
            No rankings fluff — visa math, real costs and settlement clocks, compared side by side the way our counsellors actually decide.
          </p>
        </div>
      </section>

      <section className="bg-slate-50 py-12 lg:py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid sm:grid-cols-2 gap-5" data-testid="cmp-index-grid">
            {COMPARISON_LIST.map((c, i) => (
              <Link
                key={c.slug}
                to={`/study-abroad/comparison/${c.slug}/`}
                className="group rounded-2xl bg-white border border-slate-200 hover:border-[#C5A028]/50 hover:shadow-xl hover:-translate-y-1 transition-all p-6 sm:p-7 flex flex-col"
                data-testid={`cmp-index-card-${i}`}
              >
                <div className="flex items-center gap-3 text-2xl mb-4" aria-hidden="true">
                  <span>{c.a.flag}</span>
                  <span className="text-[#C5A028] font-syne font-bold text-sm">vs</span>
                  <span>{c.b.flag}</span>
                </div>
                <h2 className="text-lg font-bold font-syne text-[#003087] leading-tight mb-2 group-hover:text-[#001F5C]">
                  {c.title}
                </h2>
                <p className="text-sm text-slate-600 leading-relaxed mb-4 flex-1">{c.intro}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-bold text-[#856B1C]">
                  Read the comparison <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" aria-hidden="true" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ComparisonIndexPage;
